import { useParams } from 'react-router';
import { SchemaType } from '../templates/form';

export interface RouteParamsTypes {
  type: keyof SchemaType;
  template: string;
}

export const useRouteParams = () => useParams<RouteParamsTypes>();
